/**
 * Reference-counted z-index ladder for layered UI (modals, popovers, drawers).
 *
 * Each call to acquireZIndex() returns the next free integer above the base
 * and increments the cursor. release decrements when the layer unmounts.
 * Layers are ordered by acquisition order, which matches user-perceived stack
 * order (the most recently opened layer is on top).
 *
 * Tokens reserved:
 *   2000+   modals + popovers + drawers (this stack)
 *   3000+   toasts (must always sit above anything in this stack)
 */

const BASE_Z_INDEX = 2000;
let cursor = BASE_Z_INDEX;
let activeCount = 0;

export function acquireZIndex(): number {
    activeCount += 1;
    cursor += 1;
    return cursor;
}

export function releaseZIndex(): void {
    activeCount = Math.max(0, activeCount - 1);
    if (activeCount === 0) {
        cursor = BASE_Z_INDEX;
    }
}

export const TOAST_Z_INDEX = 3000;
